export { default } from './MainHeading'
export * from './MainHeading'
